/* tslint:disable */
/* eslint-disable */
export enum SignaturePadType {
  Checkout = 'checkout',
  Checkin = 'checkin'
}
